import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';
// @ts-ignore
import { makeSelectSubmitting } from 'shared';

// Global Types
import { AppState } from 'services/types';

// Global Components
import ButtonLink from 'components/ButtonLink';
import AlignLeftAndRight from 'components/AlignLeftAndRight';

// Global Actions
import { requestSaveEntities } from 'services/entities/actions';

// Global Selectors
import { selectUnsavedEntitiesExist } from 'services/entities/selectors';

interface ConnectedProps {
    unsavedEntitiesExist?: boolean;
    isSubmitting?: boolean;
}

interface DispatchProps {
    requestSaveEntities: typeof requestSaveEntities;
}

type Props = ConnectedProps & DispatchProps;

interface State {
    showSuccess: boolean;
}

export class EntitiesSaveMessageComponent extends React.PureComponent<
    Props,
    State
> {
    state = {
        showSuccess: false
    };

    timer: NodeJS.Timer | null = null;

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (prevProps.isSubmitting && !props.isSubmitting) {
            this.triggerSuccess();
        }
    }

    componentWillUnmount(): void {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    triggerSuccess = (): void => {
        this.setState({ showSuccess: true }, () => {
            this.triggerTimeout();
        });
    };

    triggerTimeout = (): void => {
        this.timer = setTimeout(() => {
            this.setState({ showSuccess: false });
        }, 5000);
    };

    handleClick = (): void => {
        const { props } = this;
        props.requestSaveEntities();
    };

    render(): React.ReactElement | null {
        const { isSubmitting, unsavedEntitiesExist } = this.props;
        const { showSuccess } = this.state;

        if (isSubmitting) {
            return <Message info>Uploading changes...</Message>;
        }

        if (unsavedEntitiesExist) {
            return (
                <Message warning>
                    <AlignLeftAndRight
                        left="Changes need uploading"
                        right={
                            <ButtonLink
                                buttonProps={{
                                    color: 'orange'
                                }}
                                onClick={this.handleClick}
                            >
                                Upload now
                            </ButtonLink>
                        }
                    />
                </Message>
            );
        }

        if (showSuccess) {
            return <Message success>All changes uploaded</Message>;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    unsavedEntitiesExist: selectUnsavedEntitiesExist,
    isSubmitting: makeSelectSubmitting('ENTITIES_SAVE')
});

export default connect(
    mapStateToProps,
    { requestSaveEntities }
)(EntitiesSaveMessageComponent);
